export default "__VITE_ASSET__a0f82c4e__"